// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"a358abc1","498":"8c7f5c60","598":"eab6c671"}[chunkId] + ".chunk.js";
};